module.exports = __webpack_public_path__ + "static/media/landing-footer-mosaic.3d8ee232.png";